module.exports = __webpack_public_path__ + "img/gif.5c23a1a2.gif";